import React, { Component } from 'react'
import FocusTrap from 'focus-trap-react'

import './lgy-modal.scss'
import closeSvg from 'uswds/dist/img/close.svg'

/**
 * Wrap this around components to show them in a modal dialog (like a pop-up but not).
 * 'show' prop must be controlled or the scroll bar won't behave correctly.
 * Provide callback to onClose prop for close button functionality.
 * Override 'modal-dialog-div' class in your gear to customize appearance.
 * 
 * @author Nic Ebner
 *
 * @param {Object} props Component props
 * @param {Boolean} props.show whether you want to show the modal or not
 * @param {Function} props.onClose function that is called when the modal is closed
 * @param {Array.<ReactElement>} children the child elements of LgyModalDialog
 *
 * @return {ReactElement}
 */

export default class LgyModalDialog extends Component {

  state = { showModal: this.props.show }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      if (this.props.show && !this.state.showModal) {
        this.openModal()
      } else if (!this.props.show && this.state.showModal) {
        this.closeModal()
      }
    }
  }

  closeModal = () => {
    document.body.style.setProperty('overflow-y', 'initial')
    this.setState({ showModal: false })
  }

  openModal = () => {
    document.body.style.setProperty('overflow-y', 'hidden')
    this.setState({ showModal: true })
  }

  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose()
    }
    this.closeModal()
  }

  render() {
    return (
      this.state.showModal && <FocusTrap>
        <div className='lgy-modal'>
          <div className='modal-overlay-div' />
          <div className='modal-content-div'>
            <div className='modal-dialog-div' role='dialog' aria-modal='true'>
              <button className='usa-button close-button' aria-label='Close' onClick={this.handleClose}>
                <img src={closeSvg} alt='close' />
              </button>
              {this.props.children}
            </div>
          </div>
        </div>
      </ FocusTrap>
    )
  }
}
